import React, {useState, useEffect} from 'react';
import {
  Button,
  Typography
} from '@mui/material';

export default function FdlButton(props) {
  const { text, startIcon, endIcon, onClick, fontSize, buttonHeight, buttonWidth, type, style, disabled, dependsOn } = props
  const [isDisabled, setIsDisabled] = useState(disabled)
 
  // By putting ...style at the bottom of the style object
  // we ensure that any style passed as props will effectively overwrite the component's default
  const baseStyle = {
    backgroundColor: 'rgba(107, 164, 125, 1)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgb(178, 235, 177)',
    },
    textTransform: 'none',
    fontWeight: 'bold',
    ...style
  };

  const disabledStyle = {
    ...style,
    backgroundColor: 'rgba(107, 164, 125, 0.6)',
    // color: 'rgba(0, 0, 0, 0)',
    textTransform: 'none',
    fontWeight: 'bold'
  }

  const [myStyle, setMyStyle] = useState(baseStyle)


  // If all of the fields that this button depends on have values (entry string lengths greater than 0)
  // Set disabled to false and apply the base style
  // Otherwise apply the disabled style
  useEffect(() => {
    if (isDisabled) {
      setMyStyle(disabledStyle);
    } else {
      setMyStyle(baseStyle);
    }
  }, [isDisabled]);

  let shouldDisable;
  if (dependsOn !== undefined) {
      shouldDisable = false;
      for(let item in dependsOn){
        if(dependsOn[item] !== undefined){
          if (dependsOn[item].length == 0) {
            shouldDisable = true;
            break;
          }
        }
      }
      if (isDisabled !== shouldDisable) {
        setIsDisabled(shouldDisable);
      }
  }else{
    // Otherwise if we are not using the dependsOn prop and ARE using the disabled prop, respect the disabled prop
    if (isDisabled !== disabled) {
      setIsDisabled(disabled);
    }
  }


  return (
    <Button
      type={type}
      variant="contained"
      style={myStyle}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        height: buttonHeight,
        width: buttonWidth
      }}
      disabled={isDisabled}
    >
      <Typography fontSize={fontSize}>{text}</Typography>
    </Button>
  );
};